<app-single-card [title]="title" [description]="description"></app-single-card>